export default "/images/award.svg?1ca6c258ab69c5aa417a7f3f04f29e65";